module.exports = __webpack_public_path__ + "img/banner_news_m.ecbc5f9e.jpg";